module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/bodyOil@2x_5348ef.png";